import { useToast } from "vue-toastification";
import Notification from "@/ui-kit/Notification.vue";
import { NOTIFICATION_TYPES } from "@/constants";

export const useToastNotifications = () => {
  const toast = useToast();

  const execute = (type, title, props = {}, listeners = {}) => {
    toast(
      {
        component: Notification,
        props: {
          type,
          title,
          ...props,
        },
        listeners,
      },
      {
        icon: false,
        closeButton: false,
        hideProgressBar: true,
        timeout: 3000,
      }
    );
  };

  const info = (...args) => {
    execute(NOTIFICATION_TYPES.INFO, ...args);
  };

  const success = (...args) => {
    execute(NOTIFICATION_TYPES.SUCCESS, ...args);
  };

  const error = (...args) => {
    execute(NOTIFICATION_TYPES.ERROR, ...args);
  };

  const warning = (...args) => {
    execute(NOTIFICATION_TYPES.WARNING, ...args);
  };

  return { info, success, error, warning };
};
